import React, { useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTheme } from "styled-components";
import ReactTags from "react-tag-autocomplete";

export default ({ suggestions, tags, onChange }) => {
  const [currentTags, setCurrentTags] = useState(tags || []);
  return (
    <ReactTags
      inputAttributes={{
        size: "40"
      }}
      delimiters={[13, 9, 188]}
      autoresize={false}
      autofocus={false}
      placeholder="Add tags, use comma or enter as delimiters"
      tags={currentTags}
      suggestions={suggestions}
      allowNew={true}
      handleDelete={i => {
        const newTags = currentTags.filter((_, index) => index !== i);
        setCurrentTags(newTags);
        if (onChange) {
          onChange(newTags);
        }
      }}
      handleAddition={tag => {
        const newTags = currentTags.concat([tag]);
        setCurrentTags(newTags);
        if (onChange) {
          onChange(newTags);
        }
      }}
    />
  );
};
